export const GET_ADMINS = "GET_ADMINS";
export const ADD_ADMIN = "ADD_ADMIN";
export const EDIT_ADMIN = "EDIT_ADMIN";
export const GET_ADMIN = "GET_ADMIN";
export const RESET_ADMIN = "RESET_ADMIN";
export const ERROR_ADMIN = "ERROR_ADMIN";
export const GET_ALL_ADMINS = "GET_ALL_ADMINS";
